import { render, staticRenderFns } from "./PconEditPrcsChild.vue?vue&type=template&id=4f6f08a2&scoped=true&"
import script from "./PconEditPrcsChild.vue?vue&type=script&lang=js&"
export * from "./PconEditPrcsChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f08a2",
  null
  
)

export default component.exports